export default "__VITE_ASSET__C_ppVK$u__"